import { createFileRoute, Outlet } from '@tanstack/react-router';
import CaseList from '../../../../Components/CaseList';
import { useCaseViewPermission } from '../../../../Hooks/useCaseViewPermission';

export const Route = createFileRoute('/(main)/_layout/cases/_cases')({
  component: RouteComponent,
});

function RouteComponent() {
  useCaseViewPermission();

  return (
    <div className="cases-list">
      <CaseList />
      <Outlet />
    </div>
  );
}
